<template>
  <div class="cp-article-detail-view">
    <!-- <div class="cp-article-detail-view-breadcrumbs-container">
      <Breadcrumbs />
    </div> -->
    <div v-if="article" class="cp-article-detail-view-container">
      <p
        :class="['cp-article-detail-view-product-name']"
        class="title is-3 has-text-link has-text-left"
      >
        {{ article.title_localized }}
      </p>

      <img
        class="cp-article-detail-view-cover-image"
        v-if="article.cover_image"
        :src="article.cover_image"
      />

      <Reader :content="article.content_localized" />

      <!-- <hr class="has-background-primary" />
      <p>Credit: www.cloverplus.com</p> -->
      <br />

      <XContainer>
        <p
          :class="['has-text-weight-bold', 'has-text-primary', 'is-size-4', 'has-text-centered']"
          class="cp-article-detail-view-related-articles"
        >
          {{ $t('articles.related.articles') }}
        </p>

        <p
          v-if="!relatedArticles.length"
          :class="['has-text-weight-bold', 'has-text-grey', 'is-size-5', 'has-text-centered']"
          class="cp-article-detail-view-no-related-articles"
        >
          {{ $t('articles.no.related.articles') }}
        </p>

        <div v-if="relatedArticles.length" class="cp-article-detail-view-horizontal-list-container">
          <Article
            class="cp-article-detail-view-item"
            v-for="(article, index) in relatedArticles"
            :key="index"
            :image="article.cover_image"
            :title="article.title_localized"
            :excerpt="article.prefix_localized"
            @click="gotoArticlePage(article.id)"
          />
        </div>
      </XContainer>
    </div>
  </div>
</template>

<script>
import Article from '@/components/Article.vue';
import Reader from '@/components/Quill/Reader.vue';
import XContainer from '@/components/XContainer.vue';
import { getArticle, getRelatedArticles } from '@/apis/article';
// import { getArticle, getRelatedArticles, viewArticle } from '@/apis/article';
// import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs.vue';

export default {
  name: 'ArticleView',
  components: {
    Reader,
    XContainer,
    Article,
    // Breadcrumbs,
  },
  watch: {
    $route: 'fetchData',
  },
  data() {
    return {
      article: null,
      relatedArticles: [],
    };
  },
  async mounted() {
    await this.fetchData();
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('updateCurrentArticleTitle', '');
    next();
  },
  methods: {
    async fetchData() {
      const loading = this.$buefy.loading.open();

      try {
        this.article = await getArticle(this.$route.params.id);
        this.$store.commit('updateCurrentArticleTitle', this.article.title_localized);
        this.relatedArticles = await getRelatedArticles(this.article.category_id, this.article.id);
        // await viewArticle(this.article.id);

        window.scrollTo({ top: 0, behavior: 'smooth' });
      } finally {
        loading.close();
      }
    },
    gotoArticlePage(id) {
      if (id.toString() === this.$route.params.id.toString()) {
        window.scrollTo({ top: 0, behavior: 'smooth' });

        return;
      }

      this.$router.push({
        name: 'ArticleDetail',
        params: {
          id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.cp-article-detail-view {
  &-breadcrumbs-container {
    border-top: 1px solid $primary;
    border-bottom: 1px solid $primary;
  }

  &-container {
    padding-top: 40px;
    width: 80%;
    margin-left: auto;
    margin-right: auto;
  }

  &-cover-image {
    width: 100%;
    margin-bottom: 20px;
  }

  &-related-articles {
    padding-top: 40px;
    padding-bottom: 40px;
  }

  &-horizontal-list-container {
    padding-left: 20px;
    padding-right: 20px;
    display: flex;
    overflow-x: auto;
    width: 100%;
    height: 380px;
  }

  &-item {
    flex-shrink: 0;
  }

  &-item:first-child {
    margin-left: auto;
  }

  &-item:last-child {
    margin-right: auto;
  }

  &-no-related-articles {
    padding-bottom: 40px;
  }
}
</style>
